import { styled } from '@mui/material';

export default styled('div')({
  fontSize: 24,
  lineHeight: '32px',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: 48,
});
